import { createContext } from 'react';

interface PermitFormErrorsContext {
  formErrorKeys: string[];
}

export const PermitFormErrorsContext = createContext<PermitFormErrorsContext>({
  formErrorKeys: [],
});
